export default __webpack_public_path__ + "static/media/shareholding_logo.c46fca76.png";